"use strict";

import getNgModule from "getNgModule";
const ngModule = getNgModule(__filename);

ngModule.factory("obsPresentationPopin", function ($modal, $localStorage) {

    var POPIN_OPENED_KEY = "obsPopinOpened";


    var openPopin = function() {
        return $modal.open({
            controller  : "obsPresentationPopinCtrl",
            template    : require("./obsPresentationPopin.html"),
            options: {
                width: 850
            }
        });
    };

    return {

        openIfFirstTime : function() {
            if(!$localStorage.getItem(POPIN_OPENED_KEY)) {
                openPopin();
                $localStorage.setItem(POPIN_OPENED_KEY, true);
            }
        },

        open : function() {
            return openPopin();
        }

    };
});



// WEBPACK FOOTER //
// ./src/apps/observatoire/ng/presentation/obsPresentationPopin.js